module.exports = __webpack_public_path__ + "assets/img/icon-2.20842a66.svg";